// fixLoginLinks.js
function fixLoginLinks(selectors = []) {
  selectors.forEach(selector => {
    document.querySelectorAll(`${selector} a`).forEach(link => {
      const rawHref = link.getAttribute('href');
      if (!rawHref) return;

      const match = rawHref.match(/^\/([a-z]{2}(?:-[a-z]{2})?)?(\/customer_authentication.*)$/i);
      if (!match) return;

      const locale = match[1] ? `/${match[1]}` : '';
      const rest = match[2];

      const [pathPart, queryString] = rest.split('?');
      const params = new URLSearchParams(queryString || '');
      let returnTo = params.get('return_to');

      if (returnTo) {
        try { returnTo = decodeURIComponent(returnTo); } catch (_) {}

        if (locale && !returnTo.startsWith(locale)) {
          if (!returnTo.startsWith('/')) returnTo = '/' + returnTo;
          returnTo = locale + returnTo;
        }

        params.set('return_to', returnTo);
      }

      const newHref =
        params.toString()
          ? `${pathPart}?${params.toString().replace(/%2F/g, '/')}`
          : pathPart;

      link.setAttribute('href', newHref);
    });
  });
}

// expose for global usage
window.fixLoginLinks = fixLoginLinks;
